/**
 * Template for Feedback
 * @param {*} fields
 */
export function Feedback({
    device_id,
    room_id,
    status,
    message,
    update_time,
    rating,
}) {
    this.deviceId = device_id;
    this.roomId = room_id;
    this.status = status;
    this.rating = rating;
    this.message = message;
    this.updateTime = update_time;
}